export default {
  serverUrl: "http://hamonisync-env-2.mgddeenjpq.eu-west-1.elasticbeanstalk.com"
};
